import { render, staticRenderFns } from "./EsAfile.vue?vue&type=template&id=22bc04f2"
import script from "./EsAfile.vue?vue&type=script&lang=js"
export * from "./EsAfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports